module.exports = __webpack_public_path__ + "static/scale-model-of-van-der-donck-park-in-yonkers-new-york-09032f3e0a22b237b7d3b80998ab76fe.png";